<template>
  <div v-if="status" class="colaborador-status">
    <div class="colaborador-status-chips">
      <v-chip small :color="status.color" :text-color="status.textColor">
        {{ status.label }}
      </v-chip>
      <v-tooltip v-for="alerta in alertasAgrupados" :key="alerta.label" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            x-small
            :color="alerta.color"
            :text-color="alerta.textColor"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon x-small left>{{ alerta.icon }}</v-icon>
            {{ alerta.label }}
          </v-chip>
        </template>
        <div v-for="descricao in alerta.descricoes" :key="descricao">
          {{ descricao }}
        </div>
      </v-tooltip>
    </div>

    <div
      v-if="status.detalhe && status.detalhe.tipo === 'ocupacao'"
      class="status-ocupacao"
    >
      <div class="status-ocupacao-titulo">
        <router-link
          v-if="status.detalhe.idAtendimento"
          :to="`/fluxo-servico-funerario/${status.detalhe.idAtendimento}`"
          class="status-ocupacao-link"
          @click.native.stop
        >
          #{{ status.detalhe.idAtendimento }}
        </router-link>
        <span
          v-if="status.detalhe.idAtendimento && status.detalhe.atividadeNome"
        >
          - {{ status.detalhe.atividadeNome }}
        </span>
        <span v-if="!status.detalhe.idAtendimento">
          {{ status.detalhe.titulo }}
        </span>
      </div>
      <div class="status-ocupacao-detalhe">{{ status.detalhe.subtitulo }}</div>
    </div>
    <div v-else-if="status.detalhe" class="status-indisponibilidade">
      {{ status.detalhe.titulo }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ColaboradorStatusDisponibilidade",
  props: {
    status: {
      type: Object,
      default: null,
    },
  },
  computed: {
    alertasAgrupados() {
      const grupos = new Map();
      (this.status?.alertas || []).forEach((alerta) => {
        const grupo = grupos.get(alerta.label);
        if (grupo) {
          grupo.descricoes.push(alerta.descricao);
          return;
        }
        grupos.set(alerta.label, { ...alerta, descricoes: [alerta.descricao] });
      });
      return Array.from(grupos.values());
    },
  },
};
</script>

<style scoped>
.colaborador-status {
  padding: 6px 0;
}

.colaborador-status-chips {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.status-indisponibilidade {
  margin-top: 4px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.3;
  white-space: normal;
}

.status-ocupacao {
  margin-top: 4px;
  color: #6b5600;
  font-size: 11px;
  line-height: 1.3;
  white-space: normal;
}

.status-ocupacao-titulo {
  font-weight: 700;
}

.status-ocupacao-link {
  color: inherit;
  text-decoration: underline;
}

.status-ocupacao-detalhe {
  color: #856b00;
  margin-top: 1px;
}
</style>
